import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

const Header = () => {
  // Obtiene la ruta actual const location = useLocation();

  useEffect(() => {
    // Inicializar el menú móvil cuando el componente se monte
    const initMobileMenu = () => {
      // Simular la funcionalidad de nav-menu.js
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarNav = document.querySelector('.navbar-nav');
      
      if (navbarToggler && navbarNav) {
        // Remover cualquier event listener previo
        const newNavbarToggler = navbarToggler.cloneNode(true);
        navbarToggler.parentNode.replaceChild(newNavbarToggler, navbarToggler);
        
        newNavbarToggler.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          this.classList.toggle('menu-opened');
          
          if (navbarNav.style.display === 'block') {
            navbarNav.style.display = 'none';
            navbarNav.classList.remove('open');
          } else {
            navbarNav.style.display = 'block';
            navbarNav.classList.add('open');
          }
        });
        
        // Agregar botones para submenús
        const hasSubItems = document.querySelectorAll('.navbar-nav > li:has(ul)');
        hasSubItems.forEach(item => {
          if (!item.querySelector('.submenu-button')) {
            const button = document.createElement('span');
            button.className = 'submenu-button';
            button.innerHTML = '+';
            button.style.cssText = 'position:absolute;right:10px;top:10px;cursor:pointer;';
            item.style.position = 'relative';
            item.insertBefore(button, item.querySelector('ul'));
            
            button.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              const subMenu = this.nextElementSibling;
              if (subMenu) {
                subMenu.style.display = subMenu.style.display === 'block' ? 'none' : 'block';
              }
            });
          }
        });
      }
    };
    
    // Ejecutar después de un pequeño delay para asegurar que el DOM esté listo
    setTimeout(initMobileMenu, 100);
    
    // También ejecutar cuando la ventana cambie de tamaño
    const handleResize = () => {
      if (window.innerWidth > 991) {
        const navbarNav = document.querySelector('.navbar-nav');
        if (navbarNav) {
          navbarNav.style.display = '';
          navbarNav.classList.remove('open');
        }
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler) {
          navbarToggler.classList.remove('menu-opened');
        }
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="header-style1 menu_area-light">
      <div className="navbar-default border-bottom border-color-light-white">
        <div className="container-fluid px-lg-1-6 px-xl-2-5 px-xxl-2-9">
          <div className="row align-items-center">
            <div className="col-12 col-lg-12">
              <div className="menu_area alt-font">
                <nav className="navbar navbar-expand-lg navbar-light p-0">
                  <div className="navbar-header navbar-header-custom">
                    <a href="/" className="navbar-brand">
                      <img id="logo" src="/assets/img/logos/logo-inner.png" alt="logo decototal" />
                    </a>
                  </div>
                  
                  {/* Botón hamburguesa - Asegúrate que tenga la clase correcta */}
                  <div 
                    className="navbar-toggler bg-secondary"
                    style={{cursor: 'pointer'}}
                  ></div>
                  
                  <ul className="navbar-nav ms-auto" id="nav">
                    <li><a href="/recubrimientos-pisos">Pisos</a>
                      <ul>
                        <li><a href="/pisos-spc-premium">Pisos SPC Luxury <span className="menu-badge-new">Nuevo</span></a></li>
                        <li><a href="/piso-vinilico-lvt-page">Pisos LVT</a></li>
                        <li><a href="/piso-deck-sintetico-page">Piso Deck</a></li>
                        <li><a href="/deck-tablon-wpc">Tablones WPC <span className="menu-badge-new">Nuevo</span></a></li>
                        <li><a href="/piso-de-pvc-rigido">Piso de PVC</a></li>
                        <li><a href="/piso-de-caucho-page">Piso de Caucho</a></li>  
                      </ul>
                    </li>

                    <li><a href="/recubrimientos-muros">Muros y Techos </a>
                      <ul>
                        {/*<li><a href="/muro-carbon-de-bambu">Muros Carbón de Bambu</a></li>*/} 
                        <li><a href="/muro-lambrin-concavo">Muro Lambrin Cóncavo</a></li>
                        <li><a href="/muro-placa-tipo-marmol-page">Placa Tipo Mármol</a></li>
                        <li><a href="/muro-lambrin-sintetico-page">Muro Lambrin</a></li>
                        <li><a href="/techo-plafon-falso-page">Plafón Falso de PVC</a></li>
                        <li><a href="/vigueta-wpc-page">Vigueta Wpc</a></li>
                        <li><a href="/muro-bamboo-espejo">Muro Bamboo Espejo</a></li>
                      </ul>
                    </li>

                    <li><a href="#!">Hogar </a>
                      <ul>
                        <li><a href="/escritorios-escolares">Escritorios Escolares</a></li>
                      </ul>
                    </li>
                    <li><a href="/calculadora-materiales">Calculadora de Materiales</a></li>  
                    <li><a href="/contacto-decototal">Contáctanos</a></li>  
                  </ul>
                  
                  <div className="attr-nav align-items-xl-center ms-xl-auto main-font">
                    <ul>
                      <li className="d-none d-xl-inline-block">
                        <a 
                          href="/contacto-decototal" 
                          className="butn-style4 md text-white" 
                        >
                          <span>Cotiza Ahora</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;